export default {"src":"/_next/static/media/maestro.dd7c3dea.svg","height":512,"width":512};